// extracted by mini-css-extract-plugin
module.exports = {"linkCategory":"FooterChildLinks-module--linkCategory--1cUuU","slideElement":"FooterChildLinks-module--slideElement--2tCao"};